module.exports = __webpack_public_path__ + "img/tarjeta.0ac14727.png";